const locale = {
  placeholder: 'Цаг сонгох',
};

export default locale;
